module.exports = __webpack_public_path__ + "static/media/pioneer0.7c64e1cb.jpg";